import React, {Fragment} from "react";
import {Card, CardContent, Grid, Typography} from "@mui/material";
import {sprintf} from "sprintf-js";
import {ChecklistField, LeadChecklistField} from "../formFields/ChecklistField";
import ChecklistItemDefault from "../defaults/ChecklistItemDefault";

const [section, name] = [3, "Bathroom"];

const BathroomDefaults = () => {
    return {
        "3": {
            "1": ChecklistItemDefault,
            "2": ChecklistItemDefault,
            "3": ChecklistItemDefault,
            "4": ChecklistItemDefault,
            "5": ChecklistItemDefault,
            "6": ChecklistItemDefault,
            "7": ChecklistItemDefault,
            "8": ChecklistItemDefault,
            "9": ChecklistItemDefault,
            "10": ChecklistItemDefault,
            "11": ChecklistItemDefault,
            "12": ChecklistItemDefault,
            "13": ChecklistItemDefault,
        }
    };
}

const Bathroom = () => {
    const relPath = name;
    return (
        <Fragment>
            <Card>
                <CardContent>
                    <Typography variant={"h6"} gutterBottom>
                        {sprintf("%d. %s", section, name)}
                    </Typography>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "present")}
                            rank={"3.1"}
                            room={name}
                            desc={"Bathroom Present"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "electricity")}
                            rank={"3.2"}
                            room={name}
                            desc={"Electricity"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "electricalHazard")}
                            rank={"3.3"}
                            room={name}
                            desc={"Free of Electrical Hazards"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "security")}
                            rank={"3.4"}
                            room={name}
                            desc={"Security"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "windowCondition")}
                            rank={"3.5"}
                            room={name}
                            desc={"Window Condition"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "ceilingCondition")}
                            rank={"3.6"}
                            room={name}
                            desc={"Ceiling Condition"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "wallCondition")}
                            rank={"3.7"}
                            room={name}
                            desc={"Wall Condition"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "floorCondition")}
                            rank={"3.8"}
                            room={name}
                            desc={"Floor Condition"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <LeadChecklistField
                            path={sprintf("%s.%s", relPath, "leadPaint")}
                            rank={"3.9"}
                            room={name}
                            desc={"Lead-Based Paint"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "toilet")}
                            rank={"3.10"}
                            room={name}
                            desc={"Flush toilet in enclosed room in unit"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "washBasin")}
                            rank={"3.11"}
                            room={name}
                            desc={"Fixed wash basin or lavatory in unit"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "showerBath")}
                            rank={"3.12"}
                            room={name}
                            desc={"Tub or shower in unit"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "ventilation")}
                            rank={"3.13"}
                            room={name}
                            desc={"Ventilation"}
                            section={section}
                        />
                    </Grid>

                </CardContent></Card>
        </Fragment>
    );
};

export default Bathroom;
export {BathroomDefaults};